<template>
  <div class=" flex  py-4  gap-4">
    <div v-if="this.visibleScroll" @click="scrollLeft" class="w-10 border-white h-10 shrink-0 cursor-pointer border-2 font-bold flex items-center justify-center rounded-full bg-white">
      <i class="fas fa-chevron-left"></i>
    </div>
    <PerfectScrollbar ref="categoriesContainer" class="max-w-[calc(100%_-_140px)] relative overflow-hidden pb-2">
      <div class="flex gap-6">
        <div
          v-if="sub_categories.length > 0"
          @click="$emit('select', null)"
          class="py-2 px-3 rounded-lg text-gray-500 cursor-pointer font-bold text-sm shrink-0"
          :class="{
            '!text-black': selectedSubCategory == null,
            'hover:!text-black': selectedSubCategory != null
          }"
        >
          All
        </div>
        <div v-for="sub_category in sub_categories" :key="sub_category.id"
            @click="$emit('select', sub_category.id)"
            class="py-2 px-3 rounded-lg text-gray-500 cursor-pointer font-bold text-sm shrink-0"
            :class="{
              'hover:!text-black': selectedSubCategory != sub_category.id,
              '!text-black': selectedSubCategory == sub_category.id
            }"> 
          
          {{ sub_category.name }}
        </div>
      </div>
    </PerfectScrollbar>
    <div v-if="this.visibleScroll" @click="scrollRight" class="w-10 border-white h-10 shrink-0 cursor-pointer border-2 font-bold flex items-center justify-center rounded-full bg-white">
      <i class="fas fa-chevron-right"></i>
    </div>
  </div>
</template>

<script>
  import { PerfectScrollbar } from 'vue2-perfect-scrollbar'

  export default {
    name: 'CategoriesSelector',
    props: {
      sub_categories: Array,
      selectedSubCategory: String | Number,
    },
    components: {
      PerfectScrollbar
    },
    data() {
      return {
        visibleScroll: false
      }
    },
    watch: {
      categories() {
        this.$nextTick(() => {
          this.checkScroll();
        })
      }
    },
    mounted() {
      window.addEventListener('resize', this.checkScroll)
      this.checkScroll();
    },
    beforeUnmount() {
      window.removeEventListener('resize', this.checkScroll)
    },
    methods: {
      checkScroll() {
        console.log(this.$refs.categoriesContainer?.$el.clientWidth, window.innerWidth - 260)
        this.visibleScroll = this.$refs.categoriesContainer?.$el?.clientWidth > window.innerWidth - 260;
      },
      scrollLeft() {
        this.$refs.categoriesContainer.$el.scrollBy({
          left: -50,
        })
      },
      scrollRight() {
        this.$refs.categoriesContainer.$el.scrollBy({
          left: 50
        })
      },

    }
  }
</script>